import { computed, reactive, watch } from "vue";
import { apiFetch } from "./api";

const accounts = new Map();

function accountState(email) {
  if (accounts.has(email)) return accounts.get(email);
  const key = `permitpilott:organization:${email}`;
  let selectedId = "";
  try {
    selectedId = localStorage.getItem(key) || "";
  } catch {}
  const state = reactive({
    organizations: [],
    selectedId,
    loading: false,
    busy: false,
    error: false,
    get current() {
      return (
        this.organizations.find((item) => item.id === this.selectedId) || null
      );
    },
    select(id) {
      if (!this.organizations.some((item) => item.id === id)) return;
      this.selectedId = id;
      try {
        localStorage.setItem(key, id);
      } catch {}
    },
    async load() {
      if (this.loading || this.busy) return;
      this.loading = true;
      this.error = false;
      try {
        const response = await apiFetch("/api/organizations");
        if (!response.ok) throw new Error();
        this.organizations = (await response.json()).organizations;
        if (!this.current) {
          this.selectedId = "";
          if (this.organizations.length) this.select(this.organizations[0].id);
        }
      } catch {
        this.error = true;
        this.organizations = [];
      } finally {
        this.loading = false;
      }
    },
    async create(name) {
      if (this.loading || this.busy || !name.trim()) return false;
      this.busy = true;
      try {
        const response = await apiFetch("/api/organizations", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ name: name.trim() }),
        });
        const data = await response.json();
        if (!response.ok)
          throw new Error(
            data.error || "Unable to create organization. Please retry.",
          );
        this.organizations.push(data.organization);
        this.select(data.organization.id);
        this.error = false;
        return true;
      } finally {
        this.busy = false;
      }
    },
  });
  accounts.set(email, state);
  return state;
}

export function useAccountOrganizations(user) {
  const state = computed(() => accountState(user.value?.email || ""));
  watch(
    () => user.value?.email,
    (email) => {
      if (email) void state.value.load();
    },
    { immediate: true },
  );
  return state;
}

export function clearAccountOrganizations() {
  accounts.clear();
}
